import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { QcsTypography } from '../common/basic/QcsTypography';
import { TourniquetInvitationContainer } from './TourniquetInvitationContainer';
import { QcsError } from '@api/models/QcsError';

interface Props {
  error: QcsError;
}

export const EnteringBeforeEarliestEntryTime: FC<Props> = ({ error }) => {
  const { t } = useTranslation();
  return (
    <TourniquetInvitationContainer icon="error">
      <QcsTypography>
        {t('tourniquet.issueCantEnterYet')}
        <strong>
          {error.parameters?.earliestEntryTimeInclTolerance ?? ''}
        </strong>
      </QcsTypography>
    </TourniquetInvitationContainer>
  );
};
